import React from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';

// GeoJSON dos estados do Brasil, hospedado localmente (public/data) em vez de
// buscado em runtime de um repositório de terceiros no GitHub.
const BRAZIL_GEOJSON = `${process.env.PUBLIC_URL}/data/brazil-states.geojson`;

const BrazilMap = ({ stateData = [], cityData = [], width = 800, height = 600 }) => {
  const stateMap = {};
  stateData.forEach(state => {
    stateMap[state.code] = state.count;
  });

  const maxCount = Math.max(...stateData.map(s => s.count), 1);

  const getStateColor = (stateCode) => {
    const count = stateMap[stateCode] || 0;
    if (count === 0) return '#EDE5D3';

    const intensity = count / maxCount;
    const hue = 96; // verde-oliva, alinhado à paleta do app
    const saturation = 25 + (intensity * 30);
    const lightness = 78 - (intensity * 38);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <ComposableMap
        width={width}
        height={height}
        projection="geoMercator"
        projectionConfig={{
          scale: 600,
          center: [-52, -14]
        }}
        style={{ width: '100%', height: '100%' }}
      >
        <Geographies geography={BRAZIL_GEOJSON}>
          {({ geographies }) =>
            geographies.map(geo => {
              const stateCode = geo.properties.sigla || geo.properties.UF || geo.properties.name?.substring(0, 2)?.toUpperCase();
              const count = stateMap[stateCode] || 0;

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={getStateColor(stateCode)}
                  stroke="#ffffff"
                  strokeWidth={0.5}
                  style={{
                    default: { outline: 'none' },
                    hover: {
                      fill: '#5F6E4A',
                      outline: 'none',
                      cursor: 'pointer'
                    },
                    pressed: { outline: 'none' }
                  }}
                >
                  <title>{`${geo.properties.name || stateCode}: ${count} acessos`}</title>
                </Geography>
              );
            })
          }
        </Geographies>

        {cityData.slice(0, 10).map((city, index) => (
          <Marker key={index} coordinates={[city.longitude, city.latitude]}>
            <circle
              r={Math.min(4 + (city.count / 5), 12)}
              fill="#B5654A"
              stroke="#fff"
              strokeWidth={1}
              opacity={0.85}
              style={{ cursor: 'pointer' }}
            >
              <title>{`${city.city}, ${city.stateCode}: ${city.count} acessos`}</title>
            </circle>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
};

export default BrazilMap;
